const defaultImage = '/empty_wish.png'

export const setDefaultImage = (
  event: React.SyntheticEvent<HTMLImageElement>,
): void => {
  const target = event.target as HTMLImageElement

  target.src = defaultImage
}
